import { render } from "./AllQcms.vue?vue&type=template&id=56ddc810"
import script from "./AllQcms.vue?vue&type=script&lang=js"
export * from "./AllQcms.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__